import { buildModule, initSDK, type SDKApi } from '@vue-storefront/sdk';
import { type SdkModule, sdkModule } from '@vue-storefront/storefront-boilerplate-sdk';
import { magentoModule, type MagentoModuleType } from '@magento/sdk';
import { statamicModule, type StatamicModuleType } from '@statamic/sdk';
import { epicorModule, type EpicorModuleType } from '@epicor/sdk';

export const useSdk = (): SDKApi<{
  commerce: SdkModule;
  magento: MagentoModuleType;
  statamic: StatamicModuleType;
  epicor: EpicorModuleType;
}> => {
  const config = useRuntimeConfig();

  const sdkConfig = {
    commerce: buildModule<SdkModule>(sdkModule),
    magento: buildModule<MagentoModuleType>(magentoModule, {
      apiUrl: config.public.magento.apiUrl,
    }),
    statamic: buildModule<StatamicModuleType>(statamicModule, {
      apiUrl: config.public.statamic.apiUrl,
      clientId: 'statamic',
    }),
    epicor: buildModule<EpicorModuleType>(epicorModule, {
      apiUrl: config.public.epicor.apiUrl,
    })
  };

  return initSDK<typeof sdkConfig>(sdkConfig);
};
